import { PencilSimpleLine } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import PasswordInput from "common/components/PasswordInput";
import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import useCustomer from "common/datahooks/useCustomer";

import SettingsItemContainer from "../SettingsItemContainer";

export default function Password() {
  const [isEditing, setIsEditing] = useState(false);
  const { updatePassword, isUpdatingPassword } = useCustomer();
  const {
    register,
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = useForm<{
    newPassword: string;
    confirmPassword: string;
  }>({
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
  });

  function onSubmit({
    newPassword,
    confirmPassword,
  }: {
    newPassword: string;
    confirmPassword: string;
  }) {
    if (!newPassword) {
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("confirmPassword", {
        type: "manual",
        message: "Passwords do not match",
      });
      return;
    }

    updatePassword({ newPassword }).then(() => {
      setIsEditing(false);
    });
  }
  function onCancel() {
    setIsEditing(false);
    reset({
      newPassword: "",
      confirmPassword: "",
    });
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <SettingsItemContainer className="items-center gap-x-2">
        {isEditing ? (
          <>
            <div className="flex w-full gap-x-2">
              <FormField
                htmlFor="newPassword"
                label="New password"
                size="sm"
                className="flex-1"
                error={errors.newPassword?.message}
              >
                <PasswordInput
                  id="newPassword"
                  variant="sm"
                  placeholder="Enter your new password"
                  {...register("newPassword", {
                    required: "New password is required",
                  })}
                />
              </FormField>

              <FormField
                htmlFor="confirmPassword"
                label="Confirm password"
                size="sm"
                className="flex-1"
                error={errors.confirmPassword?.message}
              >
                <PasswordInput
                  id="confirmPassword"
                  variant="sm"
                  placeholder="Confirm your new password"
                  {...register("confirmPassword", {
                    required: "New password confirmation is required",
                  })}
                />
              </FormField>
            </div>
            <div className="flex gap-x-2 mt-auto ml-auto">
              <Button
                variant="secondary-black"
                type="button"
                size="sm"
                onClick={onCancel}
                disabled={isUpdatingPassword}
              >
                Cancel
              </Button>
              <Button size="sm" type="submit" isLoading={isUpdatingPassword}>
                Save
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col gap-y-0.5">
              <span className="text-sm-bold">Password</span>
              <span className="text-black-500 text-xs-medium">●●●●●●●●●●●</span>
            </div>
            <Button
              variant="ghost-black"
              intent="iconOnly"
              className="ml-auto"
              onClick={() => setIsEditing(true)}
            >
              <PencilSimpleLine />
            </Button>
          </>
        )}
      </SettingsItemContainer>
    </form>
  );
}
